import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import about from '@/pages/about'
import technology from '@/pages/technology'
import science from '@/pages/science'
import patent from '@/pages/patent'
import cooperation from '@/pages/cooperation'
import environment from '@/pages/environment'
import welfare from '@/pages/welfare'
import care from '@/pages/care'
import newslist from '@/pages/newslist'
import newspage from '@/pages/newspage'
import prodlist from '@/pages/prodlist'
import prodpage from '@/pages/prodpage'
import quality from '@/pages/quality'
import application from '@/pages/application'
import personnel from '@/pages/personnel'
import recruit from '@/pages/recruit'
import building from '@/pages/building'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    }, {
      path: '/about/:type',
      name: 'about',
      component: about
    }, {
      path: '/prodlist',
      name: 'prodlist',
      component: prodlist
    }, {
      path: '/prodpage/:id',
      name: 'prodpage',
      component: prodpage
    }, {
      path: '/personnel',
      name: 'personnel',
      component: personnel
    }, {
      path: '/recruit',
      name: 'recruit',
      component: recruit
    }, {
      path: '/quality',
      name: 'quality',
      component: quality
    }, {
      path: '/application',
      name: 'application',
      component: application
    }, {
      path: '/technology',
      name: 'technology',
      component: technology
    }, {
      path: '/science',
      name: 'science',
      component: science
    }, {
      path: '/patent',
      name: 'patent',
      component: patent
    }, {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    }, {
      path: '/environment',
      name: 'environment',
      component: environment
    }, {
      path: '/welfare',
      name: 'welfare',
      component: welfare
    }, {
      path: '/care',
      name: 'care',
      component: care
    }, {
      path: '/newslist',
      name: 'newslist',
      component: newslist
    }, {
      path: '/newspage/:id',
      name: 'newspage',
      component: newspage
    }, {
      path: '/building',
      name: 'building',
      component: building
    }
  ],
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js